module.exports = __webpack_public_path__ + "923868b117ac8dd3fbb1686200077048.svg";